{
  "ts": 1744782912,
  "tsCommit": 1744379354,
  "repoName": "NCApp3",
  "branchName": "prod",
  "rev": "dc05f48",
  "ver": "20250416_0555_NCApp3_prod_dc05f48",
  "env": "production",
  "isBranchDeployment": false,
  "appVer": "5.4.7"
}
